import { validateIsBase64 } from '@healthhub/react-ui';

import { getDefaultProfilePicDisplay } from './getDefaultProfilePicDisplay';
import { getProfilePicImage } from './getProfilePicImage';

export const getProfilePictureS3ImageDisplay = (image: null | string, gender?: null | string, age?: null | number) => {
  if (validateIsBase64(image)) {
    return getProfilePicImage(image);
  }

  if (image) {
    return image;
  }
  return getDefaultProfilePicDisplay(gender, age);
};
